export default "__VITE_ASSET__BQEf3Oxl__"